/** Locale-aware comparison for grid cell strings (numbers, dates as strings, etc.). */
export function compareGridCellStrings(a: string, b: string): number {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}

/**
 * Cycles: unsorted column → asc → desc → clear.
 * Clicking a different column starts at asc.
 */
export function nextSortState(
  currentColumn: string | null,
  currentDir: 'asc' | 'desc' | null,
  clickedColumn: string
): { column: string | null; direction: 'asc' | 'desc' | null } {
  if (currentColumn !== clickedColumn) {
    return { column: clickedColumn, direction: 'asc' };
  }
  if (currentDir === 'asc') {
    return { column: clickedColumn, direction: 'desc' };
  }
  return { column: null, direction: null };
}
